import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from "../../../../environments/environment";
import {ChatVersions} from "../../../../../shared/chat.versions";

// Лендинги существуют только в EN-версии (18sexchat.net). На VT-сборке (virt-chat)
// прямой заход по URL редиректит на главную, а не рендерит EN-контент.
export const sxOnlyGuard: CanActivateFn = () => {
    if (environment.chatVersion === ChatVersions.SX) {
        return true
    }

    return inject(Router).parseUrl('/')
}
